import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _isNil from 'lodash/isNil';
import { EMPTY_OBJECT, AppContext, UserContext, EMPTY_STRING } from 'commons-ui';
import useService from '../../utils/useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from '../../utils/formConfig';

const useCreate = () => {
	const { user } = useContext(UserContext);
	const { showAlert } = useContext(AppContext);
	const [showLoader, setShowLoader] = useState(false);
	const history = useHistory();
	const { createMessageCenterCard, getMessageCenterCardCategoriesOption } = useService();
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.category].setRenderProps({ getOptions: getMessageCenterCardCategoriesOption });

	const handleFormSubmit = async (submittedData: any) => {
		setShowLoader(true);
		try {
			const result = await createMessageCenterCard({
				category: submittedData.category,
				isActive: submittedData.isActive,
				description: { en: submittedData.en, hi: submittedData.hi },
				email: user?.email || EMPTY_STRING
			});
			if (!_isNil(result.data.error) || !result.data.success) {
				throw result;
			}
			setShowLoader(false);
			history.goBack();
			showAlert('Message center card created sucessfully!', { type: 'success' });
		} catch (err: any) {
			showAlert(err.data?.error ?? 'Error while creating Message center card', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
